// extracted by mini-css-extract-plugin
export var contentBody = "_86-9";
export var headerImage = "_86-2";
export var imageButton = "_86-7";
export var imageButtonIcon = "_86-8";
export var imageHeader = "_86-4";
export var imageHeaderText = "_86-5";
export var imageOverlay = "_86-3";
export var imageTitle = "_86-6";
export var imageWrapper = "_86-1";
export var taskList = "_86-a";
export var widget = "_86-0";